export default __webpack_public_path__ + "static/media/Arte_503_Full_Body.96c575a0.png";